import type { SVGProps } from "react";

export default function CSVIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.88522 0.90918C3.13683 0.90918 2.53027 1.51601 2.53027 2.26439V16.6448C2.53027 17.3934 3.13683 18 3.88522 18H16.111C16.8591 18 17.4662 17.3934 17.4662 16.6448V6.33378L12.4174 0.90918L3.88522 0.90918Z"
        fill="#45B058"
      />
      <path
        d="M7.94506 12.4465C7.97871 12.485 7.99794 12.533 7.99794 12.5859C7.99794 12.6869 7.91621 12.7782 7.81018 12.7782C7.7621 12.7782 7.70922 12.759 7.67556 12.7157C7.48807 12.4898 7.1705 12.3453 6.87243 12.3453C6.17025 12.3453 5.6366 12.884 5.6366 13.6487C5.6366 14.4085 6.17051 14.9518 6.87243 14.9518C7.17531 14.9518 7.47338 14.822 7.67556 14.5862C7.70895 14.5477 7.7621 14.5239 7.81018 14.5239C7.92102 14.5239 7.99794 14.6198 7.99794 14.721C7.99794 14.7691 7.97871 14.8172 7.94506 14.8556C7.69479 15.1153 7.35345 15.3078 6.87269 15.3078C5.94936 15.3078 5.22314 14.6345 5.22314 13.6487C5.22314 12.6628 5.94936 11.9895 6.87269 11.9895C7.35345 11.9898 7.6996 12.1821 7.94506 12.4465ZM9.7618 15.3081C9.28585 15.3081 8.91059 15.1494 8.63655 14.9088C8.59329 14.8703 8.57405 14.8175 8.57405 14.7646C8.57405 14.6681 8.64617 14.5624 8.76155 14.5624C8.80001 14.5624 8.84328 14.572 8.87694 14.6008C9.09809 14.7982 9.40577 14.9518 9.77623 14.9518C10.3486 14.9518 10.5313 14.6441 10.5313 14.3987C10.5313 13.5715 8.63175 14.0285 8.63175 12.8837C8.63175 12.3549 9.10289 11.994 9.73296 11.994C10.1464 11.994 10.5024 12.1188 10.7621 12.3354C10.8053 12.3738 10.8294 12.4267 10.8294 12.4796C10.8294 12.5758 10.7476 12.6719 10.6416 12.6719C10.6031 12.6719 10.5599 12.6575 10.5262 12.6286C10.2906 12.4363 9.99738 12.3498 9.70385 12.3498C9.31924 12.3498 9.04493 12.5565 9.04493 12.8597C9.04493 13.5811 10.9445 13.1674 10.9445 14.365C10.9447 14.8319 10.6274 15.3081 9.7618 15.3081ZM14.3007 12.3023L13.1899 15.0626C13.137 15.1924 13.0069 15.279 12.8726 15.279H12.863C12.7236 15.279 12.5938 15.1924 12.5406 15.0626L11.4343 12.3023C11.4247 12.2782 11.4199 12.2542 11.4199 12.2253C11.4199 12.1292 11.5062 12.0135 11.6362 12.0135C11.718 12.0135 11.7949 12.0616 11.8285 12.1433L12.8673 14.8121L13.906 12.1433C13.9348 12.0664 14.0117 12.0135 14.0983 12.0135C14.2233 12.0135 14.3146 12.1145 14.3146 12.2253C14.3149 12.2494 14.3101 12.2782 14.3007 12.3023Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4789 6.3463V6.61339H14.0601C14.0601 6.61339 12.3743 6.27686 12.4234 4.82202C12.4234 4.82202 12.479 6.3463 14.0268 6.3463H17.4789Z"
        fill="#349C42"
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4307 0.910645V4.79974C12.4307 5.24204 12.7255 6.34646 14.061 6.34646H17.4797L12.4307 0.910645Z"
        fill="white"
      />
    </svg>
  );
}
